// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ant-layout-rtl .navbar-nav .icon-button .default-lang {
  margin-left: 0;
  margin-right: 12px;
}

.navbar-nav {
  display: flex;
  flex-direction: column;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
  height: 100vh;
}
.navbar-nav:hover .menu-collapse {
  visibility: visible;
  z-index: 2;
}
.navbar-nav .menu-collapse {
  visibility: hidden;
  z-index: -1;
  position: absolute;
  top: 10px;
  right: 10px;
  padding: 4px;
  border-radius: 4px;
  cursor: pointer;
}
.navbar-nav .menu-collapse svg {
  font-size: 20px;
}
.navbar-nav .menu-collapse:hover {
  background-color: var(--grey);
}
.navbar-nav .menu-unfold {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 8px;
  cursor: pointer;
  font-size: 16px;
}
.navbar-nav .menu-unfold:hover {
  color: var(--primary);
}
.navbar-nav .icon-button {
  display: flex;
  align-items: center;
  padding: 6px 0;
  cursor: pointer;
  transition: all 0.3s ease;
}
.navbar-nav .icon-button .default-lang {
  font-size: 16px;
  color: var(--grey-dark);
  text-transform: uppercase;
  margin-left: 12px;
  mask-type: -5px;
}
.navbar-nav .icon-button .globalOutlined {
  width: 24px !important;
  height: 24px !important;
  border-radius: 50%;
  overflow: hidden;
}
.navbar-nav .icon-button .globalOutlined:hover {
  color: var(--menu);
}
.navbar-nav .icon-button .globalOutlined:hover svg {
  color: var(--menu);
}
.navbar-nav .accordion-button::after {
  width: 1rem;
  height: 1rem;
  background-size: 1rem;
}
.navbar-nav .accordion-button:not(.collapsed) {
  background: white !important;
  box-shadow: none;
}
.navbar-nav .sidebar-brand {
  position: relative;
  min-height: 70px;
  text-decoration: none;
  font-size: 14px;
  font-weight: 500;
  padding: 0 1rem;
  text-transform: uppercase;
  letter-spacing: 0.05rem;
  z-index: 1;
  display: flex;
  align-items: center;
}
.navbar-nav .sidebar-brand:hover {
  background-color: var(--calendar-date);
}
.navbar-nav .sidebar-brand .sidebar-logo {
  width: 60px;
  height: 60px;
  padding: 8px;
  border-radius: 50%;
  object-fit: cover;
  object-position: top center;
}
.navbar-nav .sidebar-brand .sidebar-brand-text .user-name {
  width: 100%;
  display: flex;
  font-size: 12px;
  justify-content: center;
  margin-bottom: 4px;
}
.navbar-nav .sidebar-brand .sidebar-brand-text .user-status {
  font-size: 11px;
  margin-bottom: 0;
}
.navbar-nav.ant-layout-sider-collapsed .sidebar-brand {
  padding: 0;
  justify-content: center;
}
.navbar-nav.ant-layout-sider-collapsed .sidebar-brand .sidebar-brand-text {
  display: none;
}
.navbar-nav.ant-layout-sider-collapsed .menu-collapse {
  display: none;
}
.navbar-nav .isActive,
.navbar-nav .logout {
  color: var(--dark) !important;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.navbar-nav .isActive .box,
.navbar-nav .logout .box {
  padding: 4.8px 24px;
  display: flex;
  text-align: left;
  width: 14rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.5s ease;
}
.navbar-nav .isActive .box i,
.navbar-nav .logout .box i {
  color: var(--dark);
  font-size: 1.1rem;
  margin-right: 0.8rem;
  display: flex;
  align-items: center;
}
.navbar-nav .isActive .box i svg,
.navbar-nav .logout .box i svg {
  font-size: 17px;
}
.navbar-nav .isActive .box span,
.navbar-nav .logout .box span {
  font-size: 0.85rem;
  display: inline;
  color: var(--dark);
}
.navbar-nav .isActive:hover,
.navbar-nav .logout:hover {
  text-decoration: none;
}
.navbar-nav .isActive:hover i,
.navbar-nav .logout:hover i {
  color: var(--menu);
  transition: color 0.5s ease;
}
.navbar-nav .isActive:hover span,
.navbar-nav .logout:hover span {
  color: var(--menu);
  transition: color 0.5s ease;
}
.navbar-nav .isActive.active,
.navbar-nav .logout.active {
  color: var(--menu) !important;
  background: var(--sidebar-active) !important;
  border-right: 3px solid var(--menu);
}
.navbar-nav .isActive.active i,
.navbar-nav .logout.active i {
  color: var(--menu);
  transition: color 0.5s ease;
}
.navbar-nav .isActive.active span,
.navbar-nav .logout.active span {
  color: var(--menu);
  transition: color 0.5s ease;
}
.navbar-nav .nav-tut {
  color: rgba(0, 0, 0, 0.63) !important;
  padding: 0 0 18px 24px;
}
.navbar-nav .nav-item {
  transition: background, width 0.5s ease;
  margin: 4px 0 8px 0 !important;
  padding: 0 !important;
  height: 40px;
}
.navbar-nav .nav-item .nav-link {
  display: flex;
  text-align: left;
  padding: 0.4rem 1.5rem;
  width: 100%;
  font-weight: 500;
  transition: all 0.5s ease;
  cursor: pointer;
}
.navbar-nav .nav-item .nav-link i {
  color: var(--dark);
  font-size: 1rem;
  margin-right: 0.8rem;
  display: flex;
  align-items: center;
}
.navbar-nav .nav-item .nav-link span {
  font-size: 0.85rem;
  display: inline;
  color: var(--dark);
}
.navbar-nav .nav-item .nav-link[data-toggle=collapse] {
  color: var(--dark);
}
.navbar-nav .nav-item .nav-link:hover {
  text-decoration: none;
}
.navbar-nav .nav-item .nav-link:hover i {
  color: var(--menu);
  transition: color 0.5s ease;
}
.navbar-nav .nav-item .nav-link:hover span {
  color: var(--menu);
  transition: color 0.5s ease;
}
.navbar-nav .nav-item .collapse {
  transition: all 0.5s ease;
}
.navbar-nav .nav-item .col {
  margin: 0 !important;
  padding: 0 !important;
}
.navbar-nav .nav-item .row,
.navbar-nav .nav-item .col .collapse {
  background: var(--white);
}
.navbar-nav .nav-item .row .collapse-inner,
.navbar-nav .nav-item .col .collapse .collapse-inner {
  background: var(--white);
  margin: 0 !important;
  padding: 0 !important;
  max-width: 102%;
  width: 102%;
}
.navbar-nav .nav-item .row .collapse-inner .active,
.navbar-nav .nav-item .col .collapse .collapse-inner .active {
  background: var(--sidebar-active) !important;
}
.navbar-nav .nav-item .row .collapse-inner .collapse-item,
.navbar-nav .nav-item .col .collapse .collapse-inner .collapse-item {
  padding: 0.75rem 1rem;
  margin: 0 0 0 15px;
  display: block;
  width: 100%;
  color: #3a3b45;
  text-decoration: none;
  border-radius: 0.35rem;
  white-space: nowrap;
}
.navbar-nav .nav-item .row .collapse-inner .collapse-item:hover,
.navbar-nav .nav-item .col .collapse .collapse-inner .collapse-item:hover {
  background: transparent;
  color: var(--menu);
}
.navbar-nav .showMenuBar {
  margin: 20px auto;
  background: var(--dark) !important;
  border: none;
  opacity: 0.9;
}
.navbar-nav .showMenuBar .left,
.navbar-nav .showMenuBar .right {
  color: white;
}

.sidebar.toggled #sidebarToggle::after {
  content: "\\f105";
  margin-left: 0.25rem;
  transition: width 0.2s linear;
}

.sidebar.toggled #sidebarToggle::after {
  color: var(--white);
  margin-left: 13px;
  width: 2.2rem;
  height: 2.2rem;
}

.sidebar.toggled {
  overflow: visible;
  width: 6.5rem !important;
  transition: width 0.2s linear;
}
.sidebar.toggled .accordion-button::after {
  display: none;
}
.sidebar.toggled .sidebar-brand {
  display: block !important;
  padding: 15px 1rem 70px 1rem;
  margin-bottom: 2rem;
  text-align: center;
  transition: width 0.2s linear;
}
.sidebar.toggled .sidebar-brand .sidebar-logo {
  width: 60px;
  padding: 8px;
  border-radius: 50%;
}
.sidebar.toggled .sidebar-brand .sidebar-brand-text .user-name {
  width: 100%;
  display: flex;
  font-size: 12px;
}
.sidebar.toggled .sidebar-brand .sidebar-brand-text .user-status {
  font-size: 12px;
  display: block;
}
.sidebar.toggled .nav-tut {
  display: none;
}
.sidebar.toggled .nav-item {
  margin: 0;
}
.sidebar.toggled .nav-item .box {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  flex-wrap: wrap;
  padding: 0;
}
.sidebar.toggled .nav-item .box .text {
  width: 100%;
  font-size: 14px !important;
  text-align: center;
  display: none;
}
.sidebar.toggled .nav-item .box .icon-log-out {
  font-size: 23px;
}
.sidebar.toggled .nav-item .box .icon-menu {
  font-size: 23px;
}
.sidebar.toggled .nav-item .box i {
  display: block;
  margin-right: 0;
  font-size: 25px !important;
}
.sidebar.toggled .nav-item .nav-link {
  text-align: center;
  padding: 0.75rem 1rem;
  width: 6.5rem;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  flex-wrap: wrap;
}
.sidebar.toggled .nav-item .nav-link .text {
  width: 100%;
  font-size: 14px !important;
  display: none;
}
.sidebar.toggled .nav-item .nav-link .icon-menu {
  font-size: 23px;
}
.sidebar.toggled .nav-item .nav-link i {
  margin-right: 0;
}
.sidebar.toggled .nav-item .nav-link[data-toggle=collapse]::after {
  display: none;
}
.sidebar.toggled .nav-item .collapse {
  position: absolute;
  left: 7.25rem;
  z-index: 1;
  top: 2px;
  animation-name: growIn;
  animation-duration: 200ms;
}
.sidebar.toggled .nav-item:last-child {
  margin-bottom: 1rem;
}

.sidebar .nav-item {
  position: relative;
}

@media (min-width: 768px) {
  .sidebar .nav-item .collapse,
  .sidebar .nav-item .collapsing {
    margin: 0 1rem;
  }
  .sidebar.toggled {
    overflow: visible;
    width: 6.5rem !important;
  }
  .sidebar.toggled .nav-item .collapse .collapse-inner {
    box-shadow: 0 0.15rem 1.75rem 0 rgba(58, 59, 69, 0.15);
    border-radius: 0.35rem;
  }
  .sidebar.toggled .nav-item .collapsing {
    display: none;
    transition: none;
  }
  .sidebar.toggled .nav-item .collapse,
  .sidebar.toggled .nav-item .collapsing {
    margin: 0;
  }
}
[data-theme=dark] .navbar-nav .menu-collapse:hover {
  background-color: var(--dark-grey);
}`, "",{"version":3,"sources":["webpack://./src/assets/scss/components/sidebar.scss"],"names":[],"mappings":"AAGM;EACE,cAAA;EACA,kBAAA;AAFR;;AAOA;EACE,aAAA;EACA,sBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,aAAA;AAJF;AAQI;EACE,mBAAA;EACA,UAAA;AANN;AAUE;EACE,kBAAA;EACA,WAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;AARJ;AASI;EACE,eAAA;AAPN;AASI;EACE,6BAAA;AAPN;AAWE;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,eAAA;EACA,eAAA;AATJ;AAUI;EACE,qBAAA;AARN;AAYE;EACE,aAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,yBAAA;AAVJ;AAWI;EACE,eAAA;EACA,uBAAA;EACA,yBAAA;EACA,iBAAA;EACA,eAAA;AATN;AAWI;EACE,sBAAA;EACA,uBAAA;EACA,kBAAA;EACA,gBAAA;AATN;AAUM;EACE,kBAAA;AARR;AASQ;EACE,kBAAA;AAPV;AAaE;EACE,WAAA;EACA,YAAA;EACA,qBAAA;AAXJ;AAcE;EACE,4BAAA;EACA,gBAAA;AAZJ;AAeE;EACE,kBAAA;EACA,gBAAA;EACA,qBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,uBAAA;EACA,UAAA;EACA,aAAA;EACA,mBAAA;AAbJ;AAcI;EACE,sCAAA;AAZN;AAcI;EACE,WAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,2BAAA;AAZN;AAgBM;EACE,WAAA;EACA,aAAA;EACA,eAAA;EACA,uBAAA;EACA,kBAAA;AAdR;AAiBM;EACE,eAAA;EACA,gBAAA;AAfR;AAoBI;EACE,UAAA;EACA,uBAAA;AAlBN;AAmBM;EACE,aAAA;AAjBR;AAoBI;EACE,aAAA;AAlBN;AAsBE;;EAEE,6BAAA;EACA,aAAA;EACA,2BAAA;EACA,mBAAA;AApBJ;AAsBI;;EACE,mBAAA;EACA,aAAA;EACA,gBAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;AAnBN;AAqBM;;EACE,kBAAA;EACA,iBAAA;EACA,oBAAA;EACA,aAAA;EACA,mBAAA;AAlBR;AAmBQ;;EACE,eAAA;AAhBV;AAoBM;;EACE,kBAAA;EACA,eAAA;EACA,kBAAA;AAjBR;AAqBI;;EACE,qBAAA;AAlBN;AAoBM;;EACE,kBAAA;EACA,2BAAA;AAjBR;AAoBM;;EACE,kBAAA;EACA,2BAAA;AAjBR;AAqBI;;EACE,6BAAA;EACA,4CAAA;EACA,mCAAA;AAlBN;AAoBM;;EACE,kBAAA;EACA,2BAAA;AAjBR;AAoBM;;EACE,kBAAA;EACA,2BAAA;AAjBR;AAsBE;EACE,qCAAA;EACA,sBAAA;AApBJ;AAuBE;EACE,uCAAA;EACA,8BAAA;EACA,qBAAA;EACA,YAAA;AArBJ;AAuBI;EACE,aAAA;EACA,gBAAA;EACA,sBAAA;EACA,WAAA;EACA,gBAAA;EACA,yBAAA;EACA,eAAA;AArBN;AAuBM;EACE,kBAAA;EACA,eAAA;EACA,oBAAA;EACA,aAAA;EACA,mBAAA;AArBR;AAwBM;EACE,kBAAA;EACA,eAAA;EACA,kBAAA;AAtBR;AAyBM;EACE,kBAAA;AAvBR;AA0BM;EACE,qBAAA;AAxBR;AA0BQ;EACE,kBAAA;EACA,2BAAA;AAxBV;AA2BQ;EACE,kBAAA;EACA,2BAAA;AAzBV;AA8BI;EACE,yBAAA;AA5BN;AA+BI;EACE,oBAAA;EACA,qBAAA;AA7BN;AAgCI;;EAEE,wBAAA;AA9BN;AAgCM;;EACE,wBAAA;EACA,oBAAA;EACA,qBAAA;EACA,eAAA;EACA,WAAA;AA7BR;AA+BQ;;EACE,4CAAA;AA5BV;AA+BQ;;EACE,qBAAA;EACA,kBAAA;EACA,cAAA;EACA,WAAA;EACA,cAAA;EACA,qBAAA;EACA,sBAAA;EACA,mBAAA;AA5BV;AA8BU;;EACE,uBAAA;EACA,kBAAA;AA3BZ;AAkCE;EACE,iBAAA;EACA,kCAAA;EACA,YAAA;EACA,YAAA;AAhCJ;AAkCI;;EAEE,YAAA;AAhCN;;AAsCA;EACE,gBAAA;EACA,oBAAA;EACA,6BAAA;AAnCF;;AAsCA;EACE,mBAAA;EACA,iBAAA;EACA,aAAA;EACA,cAAA;AAnCF;;AAsCA;EACE,iBAAA;EACA,wBAAA;EACA,6BAAA;AAnCF;AAqCE;EACE,aAAA;AAnCJ;AAsCE;EACE,yBAAA;EACA,4BAAA;EACA,mBAAA;EACA,kBAAA;EACA,6BAAA;AApCJ;AAsCI;EACE,WAAA;EACA,YAAA;EACA,kBAAA;AApCN;AAwCM;EACE,WAAA;EACA,aAAA;EACA,eAAA;AAtCR;AAyCM;EACE,eAAA;EACA,cAAA;AAvCR;AA4CE;EACE,aAAA;AA1CJ;AA6CE;EACE,SAAA;AA3CJ;AA6CI;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;EACA,eAAA;EACA,UAAA;AA3CN;AA6CM;EACE,WAAA;EACA,0BAAA;EACA,kBAAA;EACA,aAAA;AA3CR;AA8CM;EACE,eAAA;AA5CR;AA+CM;EACE,eAAA;AA7CR;AAgDM;EACE,cAAA;EACA,eAAA;EACA,0BAAA;AA9CR;AAkDI;EACE,kBAAA;EACA,qBAAA;EACA,aAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;EACA,eAAA;AAhDN;AAkDM;EACE,WAAA;EACA,0BAAA;EACA,aAAA;AAhDR;AAmDM;EACE,eAAA;AAjDR;AAoDM;EACE,eAAA;AAlDR;AAqDM;EACE,aAAA;AAnDR;AAuDI;EACE,kBAAA;EACA,aAAA;EACA,UAAA;EACA,QAAA;EACA,sBAAA;EACA,yBAAA;AArDN;AAwDI;EACE,mBAAA;AAtDN;;AA2DA;EACE,kBAAA;AAxDF;;AA2DA;EACE;;IAEE,cAAA;EAxDF;EA2DA;IACE,iBAAA;IACA,wBAAA;EAzDF;EA4DA;IACE,sDAAA;IACA,sBAAA;EA1DF;EA6DA;IACE,aAAA;IACA,gBAAA;EA3DF;EA8DA;;IAEE,SAAA;EA5DF;AACF;AAiEI;EACE,kCAAA;AA/DN","sourcesContent":[".ant-layout-rtl {\n  .navbar-nav {\n    .icon-button {\n      .default-lang {\n        margin-left: 0;\n        margin-right: 12px;\n      }\n    }\n  }\n}\n.navbar-nav {\n  display: flex;\n  flex-direction: column;\n  padding-left: 0;\n  margin-bottom: 0;\n  list-style: none;\n  height: 100vh;\n  // overflow-y: auto;\n  // overflow-x: hidden;\n  &:hover {\n    .menu-collapse {\n      visibility: visible;\n      z-index: 2;\n    }\n  }\n\n  .menu-collapse {\n    visibility: hidden;\n    z-index: -1;\n    position: absolute;\n    top: 10px;\n    right: 10px;\n    padding: 4px;\n    border-radius: 4px;\n    cursor: pointer;\n    svg {\n      font-size: 20px;\n    }\n    &:hover {\n      background-color: var(--grey);\n    }\n  }\n\n  .menu-unfold {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    margin-top: 8px;\n    cursor: pointer;\n    font-size: 16px;\n    &:hover {\n      color: var(--primary);\n    }\n  }\n\n  .icon-button {\n    display: flex;\n    align-items: center;\n    padding: 6px 0;\n    cursor: pointer;\n    transition: all 0.3s ease;\n    .default-lang {\n      font-size: 16px;\n      color: var(--grey-dark);\n      text-transform: uppercase;\n      margin-left: 12px;\n      mask-type: -5px;\n    }\n    .globalOutlined {\n      width: 24px !important;\n      height: 24px !important;\n      border-radius: 50%;\n      overflow: hidden;\n      &:hover {\n        color: var(--menu);\n        svg {\n          color: var(--menu);\n        }\n      }\n    }\n  }\n\n  .accordion-button::after {\n    width: 1rem;\n    height: 1rem;\n    background-size: 1rem;\n  }\n\n  .accordion-button:not(.collapsed) {\n    background: white !important;\n    box-shadow: none;\n  }\n\n  .sidebar-brand {\n    position: relative;\n    min-height: 70px;\n    text-decoration: none;\n    font-size: 14px;\n    font-weight: 500;\n    padding: 0 1rem;\n    text-transform: uppercase;\n    letter-spacing: 0.05rem;\n    z-index: 1;\n    display: flex;\n    align-items: center;\n    &:hover {\n      background-color: var(--calendar-date);\n    }\n    .sidebar-logo {\n      width: 60px;\n      height: 60px;\n      padding: 8px;\n      border-radius: 50%;\n      object-fit: cover;\n      object-position: top center;\n    }\n\n    .sidebar-brand-text {\n      .user-name {\n        width: 100%;\n        display: flex;\n        font-size: 12px;\n        justify-content: center;\n        margin-bottom: 4px;\n      }\n\n      .user-status {\n        font-size: 11px;\n        margin-bottom: 0;\n      }\n    }\n  }\n  &.ant-layout-sider-collapsed {\n    .sidebar-brand {\n      padding: 0;\n      justify-content: center;\n      .sidebar-brand-text {\n        display: none;\n      }\n    }\n    .menu-collapse {\n      display: none;\n    }\n  }\n\n  .isActive,\n  .logout {\n    color: var(--dark) !important;\n    display: flex;\n    justify-content: flex-start;\n    align-items: center;\n\n    .box {\n      padding: 4.8px 24px;\n      display: flex;\n      text-align: left;\n      width: 14rem;\n      font-weight: 500;\n      cursor: pointer;\n      transition: all 0.5s ease;\n\n      i {\n        color: var(--dark);\n        font-size: 1.1rem;\n        margin-right: 0.8rem;\n        display: flex;\n        align-items: center;\n        svg {\n          font-size: 17px;\n        }\n      }\n\n      span {\n        font-size: 0.85rem;\n        display: inline;\n        color: var(--dark);\n      }\n    }\n\n    &:hover {\n      text-decoration: none;\n\n      i {\n        color: var(--menu);\n        transition: color 0.5s ease;\n      }\n\n      span {\n        color: var(--menu);\n        transition: color 0.5s ease;\n      }\n    }\n\n    &.active {\n      color: var(--menu) !important;\n      background: var(--sidebar-active) !important;\n      border-right: 3px solid var(--menu);\n\n      i {\n        color: var(--menu);\n        transition: color 0.5s ease;\n      }\n\n      span {\n        color: var(--menu);\n        transition: color 0.5s ease;\n      }\n    }\n  }\n\n  .nav-tut {\n    color: rgba(0, 0, 0, 0.63) !important;\n    padding: 0 0 18px 24px;\n  }\n\n  .nav-item {\n    transition: background, width 0.5s ease;\n    margin: 4px 0 8px 0 !important;\n    padding: 0 !important;\n    height: 40px;\n\n    .nav-link {\n      display: flex;\n      text-align: left;\n      padding: 0.4rem 1.5rem;\n      width: 100%;\n      font-weight: 500;\n      transition: all 0.5s ease;\n      cursor: pointer;\n\n      i {\n        color: var(--dark);\n        font-size: 1rem;\n        margin-right: 0.8rem;\n        display: flex;\n        align-items: center;\n      }\n\n      span {\n        font-size: 0.85rem;\n        display: inline;\n        color: var(--dark);\n      }\n\n      &[data-toggle='collapse'] {\n        color: var(--dark);\n      }\n\n      &:hover {\n        text-decoration: none;\n\n        i {\n          color: var(--menu);\n          transition: color 0.5s ease;\n        }\n\n        span {\n          color: var(--menu);\n          transition: color 0.5s ease;\n        }\n      }\n    }\n\n    .collapse {\n      transition: all 0.5s ease;\n    }\n\n    .col {\n      margin: 0 !important;\n      padding: 0 !important;\n    }\n\n    .row,\n    .col .collapse {\n      background: var(--white);\n\n      .collapse-inner {\n        background: var(--white);\n        margin: 0 !important;\n        padding: 0 !important;\n        max-width: 102%;\n        width: 102%;\n\n        .active {\n          background: var(--sidebar-active) !important;\n        }\n\n        .collapse-item {\n          padding: 0.75rem 1rem;\n          margin: 0 0 0 15px;\n          display: block;\n          width: 100%;\n          color: #3a3b45;\n          text-decoration: none;\n          border-radius: 0.35rem;\n          white-space: nowrap;\n\n          &:hover {\n            background: transparent;\n            color: var(--menu);\n          }\n        }\n      }\n    }\n  }\n\n  .showMenuBar {\n    margin: 20px auto;\n    background: var(--dark) !important;\n    border: none;\n    opacity: 0.9;\n\n    .left,\n    .right {\n      color: white;\n    }\n  }\n}\n\n// dashboard app toggle change\n.sidebar.toggled #sidebarToggle::after {\n  content: '\\f105';\n  margin-left: 0.25rem;\n  transition: width 0.2s linear;\n}\n\n.sidebar.toggled #sidebarToggle::after {\n  color: var(--white);\n  margin-left: 13px;\n  width: 2.2rem;\n  height: 2.2rem;\n}\n\n.sidebar.toggled {\n  overflow: visible;\n  width: 6.5rem !important;\n  transition: width 0.2s linear;\n\n  .accordion-button::after {\n    display: none;\n  }\n\n  .sidebar-brand {\n    display: block !important;\n    padding: 15px 1rem 70px 1rem;\n    margin-bottom: 2rem;\n    text-align: center;\n    transition: width 0.2s linear;\n\n    .sidebar-logo {\n      width: 60px;\n      padding: 8px;\n      border-radius: 50%;\n    }\n\n    .sidebar-brand-text {\n      .user-name {\n        width: 100%;\n        display: flex;\n        font-size: 12px;\n      }\n\n      .user-status {\n        font-size: 12px;\n        display: block;\n      }\n    }\n  }\n\n  .nav-tut {\n    display: none;\n  }\n\n  .nav-item {\n    margin: 0;\n\n    .box {\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      flex-direction: column;\n      flex-wrap: wrap;\n      padding: 0;\n\n      .text {\n        width: 100%;\n        font-size: 14px !important;\n        text-align: center;\n        display: none;\n      }\n\n      .icon-log-out {\n        font-size: 23px;\n      }\n\n      .icon-menu {\n        font-size: 23px;\n      }\n\n      i {\n        display: block;\n        margin-right: 0;\n        font-size: 25px !important;\n      }\n    }\n\n    .nav-link {\n      text-align: center;\n      padding: 0.75rem 1rem;\n      width: 6.5rem;\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      flex-direction: row;\n      flex-wrap: wrap;\n\n      .text {\n        width: 100%;\n        font-size: 14px !important;\n        display: none;\n      }\n\n      .icon-menu {\n        font-size: 23px;\n      }\n\n      i {\n        margin-right: 0;\n      }\n\n      &[data-toggle='collapse']::after {\n        display: none;\n      }\n    }\n\n    .collapse {\n      position: absolute;\n      left: calc(6.5rem + 1.5rem / 2);\n      z-index: 1;\n      top: 2px;\n      animation-name: growIn;\n      animation-duration: 200ms;\n    }\n\n    &:last-child {\n      margin-bottom: 1rem;\n    }\n  }\n}\n\n.sidebar .nav-item {\n  position: relative;\n}\n\n@media (min-width: 768px) {\n  .sidebar .nav-item .collapse,\n  .sidebar .nav-item .collapsing {\n    margin: 0 1rem;\n  }\n\n  .sidebar.toggled {\n    overflow: visible;\n    width: 6.5rem !important;\n  }\n\n  .sidebar.toggled .nav-item .collapse .collapse-inner {\n    box-shadow: 0 0.15rem 1.75rem 0 rgba(58, 59, 69, 0.15);\n    border-radius: 0.35rem;\n  }\n\n  .sidebar.toggled .nav-item .collapsing {\n    display: none;\n    transition: none;\n  }\n\n  .sidebar.toggled .nav-item .collapse,\n  .sidebar.toggled .nav-item .collapsing {\n    margin: 0;\n  }\n}\n\n[data-theme='dark'] {\n  .navbar-nav {\n    .menu-collapse:hover {\n      background-color: var(--dark-grey);\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
